module.exports = __webpack_public_path__ + "img/result_img_failur.e6b735ef.png";